var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_230_11",
    "data-name": "Component 230 \\u2013 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215,
    height: 215,
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 102.5,
    cy: 102.5,
    r: 102.5,
    fill: "#a2a2a2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Oval-2",
    "data-name": "Oval",
    fill: "#fff",
    stroke: "#a2a2a2",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 107.5,
    r: 107.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 107.5,
    r: 106.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_14",
    "data-name": "Mask Group 14",
    transform: "translate(5 5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_120",
    "data-name": "Union 120",
    d: "M130.506,128.274c.035-4.234-11.622-14.863-19.736-21A29.571,29.571,0,0,1,92,114.454a29.54,29.54,0,0,1-18.767-7.192C65.123,113.4,53.466,124.04,53.5,128.274c.04,5.8,9.377,36.253,25.344,55.726C14.435,183.961,0,184,0,170.035c0-11.019,3.439-23.493,11.641-31.5,10.235-10,38.142-24.822,59.96-32.692A56.667,56.667,0,0,1,56.807,81.541c-7.133-.417-8.56-6.635-9.384-10.189a23.4,23.4,0,0,0-1.4-4.628c-4.506-9.593-2.488-16.674.9-20.107a9.557,9.557,0,0,1,3.451-2.232c-2.622-4.78-4.3-9.164-4.141-11.274A35.048,35.048,0,0,1,58.7,10.445C67.791,3.179,79.512,0,92,0s24.347,3.022,33.3,10.445c14.609,12.11,12.654,20.572,21.133,22.265a37.122,37.122,0,0,1-15.92,9.825c.063.422.134.834.191,1.269a9.139,9.139,0,0,1,6.369,2.806c3.386,3.435,5.41,10.509.921,20.1a22.836,22.836,0,0,0-1.42,4.651c-.824,3.555-2.256,9.761-9.378,10.178a56.667,56.667,0,0,1-14.794,24.306c21.817,7.876,49.719,22.694,59.96,32.692,8.2,8,11.634,20.477,11.634,31.5C184,184,169.565,183.961,105.162,184,121.134,164.527,130.466,134.072,130.506,128.274ZM63.719,76.16c5.144,18.3,16.244,30.116,28.285,30.116s23.145-11.818,28.289-30.116a4.09,4.09,0,0,1,4.628-2.923c2.732.47,2.721.463,3.689-3.711A29.984,29.984,0,0,1,130.6,63.22c2.429-5.183,2.1-8.8.985-10.461-.405-.6-.817-.772-.933-.772a9.26,9.26,0,0,0-1.334.714,4.09,4.09,0,0,1-6.293-3.2c-.116-1.954-.313-3.73-.551-5.427C112.075,45,98.04,42.505,79.367,32.3c-9.4-5.133-20.832,8.286-17.88,26.944a45.611,45.611,0,0,1-5.353-5.985,3.86,3.86,0,0,1-1.473-.574,9.034,9.034,0,0,0-1.311-.707,1.59,1.59,0,0,0-.923.776c-1.124,1.647-1.455,5.271.986,10.479a29.7,29.7,0,0,1,1.978,6.275c.969,4.193.969,4.193,3.7,3.723a4.1,4.1,0,0,1,4.627,2.923ZM81.82,184l5.932-43.943L82.388,137.9V127.392L92,123.531l9.616,3.861V137.9l-5.37,2.156L102.181,184Z",
    transform: "translate(12 21)",
    fill: "#a2a2a2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user-avatar.c35a4ede2cf395e38d8afd7ec250dea5.svg";
export { ForwardRef as ReactComponent };